import { FiltersModel } from '../filters';

export interface TracesFilterModel extends FiltersModel {
  location_id?: number;
  action?: string;
}
